import { render, staticRenderFns } from "./ValidateRows.vue?vue&type=template&id=36d0e76f&scoped=true"
import script from "./ValidateRows.vue?vue&type=script&lang=js"
export * from "./ValidateRows.vue?vue&type=script&lang=js"
import style0 from "./ValidateRows.vue?vue&type=style&index=0&id=36d0e76f&prod&scoped=true&lang=css"
import style1 from "./ValidateRows.vue?vue&type=style&index=1&id=36d0e76f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0e76f",
  null
  
)

export default component.exports